import { IModel, Model } from '@common/models/Model';
import { StringUtility } from '@common/utils';
import { observable } from 'mobx';

export interface IVisitSiblingModel extends IModel {
  visitId: number;
  clientId: number;
  petId: number;
  speciesId: number;
  paymentMethodId: number;
  visitStatusId: number;
  visitCompletionTypeId: number;
  speciesName: string | undefined;
  petName: string | undefined;
  paymentMethodName: string | undefined;
  visitStatusName: string | undefined;
  visitCompletionTypeName: string | undefined;
  totalAmount: number;
  taxAmount: number;
  taxableTotalAmount: number;
  nonTaxableTotalAmount: number;
  discountAmount: number;
  serviceAmount: number;
  productAmount: number;
  vetcoPrescriptionAmount: number;
  licenseFeeAmount: number;
  refundAmount: number;
  servicesOnlyDiscountAmount: number;
  productsOnlyDiscountAmount: number;
  visitCompletionIsComplete: boolean;
  consultationHasBeenValidated: boolean;
  vetServicesHasBeenValidated: boolean;
  consultationValidationStatusId: number;
  vetServicesValidationStatusId: number;
  consultationValidationStatusName: string | undefined;
  vetServicesValidationStatusName: string | undefined;
}

export class VisitSiblingModel
  extends Model
  implements Record<keyof IVisitSiblingModel, any>
{
  @observable visitId: number;
  clientId: number;
  petId: number;
  speciesId: number;
  paymentMethodId: number;
  visitStatusId: number;
  visitCompletionTypeId: number;
  speciesName: string | undefined;
  petName: string | undefined;
  paymentMethodName: string | undefined;
  visitStatusName: string | undefined;
  visitCompletionTypeName: string | undefined;
  totalAmount: number;
  taxAmount: number;
  taxableTotalAmount: number;
  nonTaxableTotalAmount: number;
  discountAmount: number;
  serviceAmount: number;
  productAmount: number;
  vetcoPrescriptionAmount: number;
  licenseFeeAmount: number;
  refundAmount: number;
  servicesOnlyDiscountAmount: number;
  productsOnlyDiscountAmount: number;
  visitCompletionIsComplete: boolean;
  consultationHasBeenValidated: boolean;
  vetServicesHasBeenValidated: boolean;
  consultationValidationStatusId: number;
  vetServicesValidationStatusId: number;
  consultationValidationStatusName: string | undefined;
  vetServicesValidationStatusName: string | undefined;

  constructor(params: IVisitSiblingModel) {
    super(params);

    this.visitId = _.defaultTo(params.visitId, 0);
    this.clientId = _.defaultTo(params.clientId, 0);
    this.petId = _.defaultTo(params.petId, 0);
    this.speciesId = _.defaultTo(params.petId, 0);
    this.paymentMethodId = _.defaultTo(params.petId, 0);
    this.visitStatusId = _.defaultTo(params.visitStatusId, 0);
    this.visitCompletionTypeId = _.defaultTo(params.visitCompletionTypeId, 0);
    this.speciesName = StringUtility.SanitizeString(params.speciesName);
    this.petName = StringUtility.SanitizeString(params.petName);
    this.paymentMethodName = StringUtility.SanitizeString(
      params.paymentMethodName,
    );
    this.visitStatusName = StringUtility.SanitizeString(params.visitStatusName);
    this.visitCompletionTypeName = StringUtility.SanitizeString(
      params.visitCompletionTypeName,
    );
    this.totalAmount = _.defaultTo(params.totalAmount, 0);
    this.taxAmount = _.defaultTo(params.taxAmount, 0);
    this.taxableTotalAmount = _.defaultTo(params.taxableTotalAmount, 0);
    this.nonTaxableTotalAmount = _.defaultTo(params.nonTaxableTotalAmount, 0);
    this.discountAmount = _.defaultTo(params.discountAmount, 0);
    this.serviceAmount = _.defaultTo(params.serviceAmount, 0);
    this.productAmount = _.defaultTo(params.productAmount, 0);
    this.vetcoPrescriptionAmount = _.defaultTo(
      params.vetcoPrescriptionAmount,
      0,
    );
    this.licenseFeeAmount = _.defaultTo(params.licenseFeeAmount, 0);
    this.refundAmount = _.defaultTo(params.refundAmount, 0);
    this.servicesOnlyDiscountAmount = _.defaultTo(
      params.servicesOnlyDiscountAmount,
      0,
    );
    this.productsOnlyDiscountAmount = _.defaultTo(
      params.productsOnlyDiscountAmount,
      0,
    );
    this.visitCompletionIsComplete = _.defaultTo(
      params.visitCompletionIsComplete,
      false,
    );
    this.consultationHasBeenValidated = _.defaultTo(
      params.consultationHasBeenValidated,
      false,
    );
    this.vetServicesHasBeenValidated = _.defaultTo(
      params.vetServicesHasBeenValidated,
      false,
    );
    this.consultationValidationStatusId = _.defaultTo(
      params.consultationValidationStatusId,
      0,
    );
    this.vetServicesValidationStatusId = _.defaultTo(
      params.vetServicesValidationStatusId,
      0,
    );
    this.consultationValidationStatusName = StringUtility.SanitizeString(
      params.consultationValidationStatusName,
    );
    this.vetServicesValidationStatusName = StringUtility.SanitizeString(
      params.vetServicesValidationStatusName,
    );
  }
}
